<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="活动名称：">
            <el-input v-model="query.activityName" placeholder="请输入活动名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="活动类型：">
            <el-select v-model="query.activityType" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="满件赠" :value="1"></el-option>
              <el-option label="满金额赠" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否限制时间：">
            <el-select v-model="query.timeLimit" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="活动商品名称：">
            <el-input v-model="query.goodsName" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item> -->
          <el-form-item label="状态：">
            <el-select v-model="query.activityStatus" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">

      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="平台满赠" name="2"></el-tab-pane>
          <el-tab-pane label="指定商品" name="1"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['goods:activity:state']">批量下架</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['goods:activity:state']">批量上架</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['goods:activity:export']">导出</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['goods:activity:add']">新增活动</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" fixed />
        <el-table-column label="活动名称" prop="activityName" align="center" width="200px" fixed>
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)">{{row.activityName}}</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column label="活动商品" prop="goodsName" align="center" :key="Math.random()">
          <template slot-scope="{row}">
            <span v-for="(item,index) in row.sysGoodsSpecValuecombineList" :key="index">{{item.goodsName}}{{row.sysGoodsSpecValuecombineList.length - 1 != index?',':''}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="活动类型" prop="" align="center">
          <template slot-scope="{row}">
            {{row.activityType === 1?'满件赠':(row.activityType === 2?'满金额赠':'')}}
          </template>
        </el-table-column>
        <el-table-column label="活动条件" prop="name" align="center">
          <template slot-scope="{row}">
            <span v-for="(item,index) in row.activityConditionList" :key="index">满{{item.fullNum}}{{row.activityType === 1?'件':''}}赠{{rewardText(item)}}{{row.activityConditionList.length - 1 != index?'，':''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" align="center" width="160">
          <template slot-scope="{row}">
            <span v-if="isPayModesDerived(row.payModes)" style="color: #909399;" title="未显式配置，按参与活动条件推导">{{payModesText(row.payModes, row.activityModules)}}</span>
            <span v-else>{{payModesText(row.payModes, row.activityModules)}}</span>
          </template>
        </el-table-column>
        <!-- REQ-2026-826259 优先级：需求要求列表和详情都展示。
             注意口径 —— 它**只在两个活动赠送价值相同时**才决定谁生效，不是优先级最高的赢，
             所以这里只做展示，不做排序入口，免得运营误以为调它就能改命中结果。 -->
        <el-table-column label="优先级" prop="priority" align="center" width="90">
          <template slot-scope="{row}">
            {{row.priority == null ? 0 : row.priority}}
          </template>
        </el-table-column>
        <el-table-column label="是否限制时间" prop="" align="center">
          <template slot-scope="{row}">
            {{row.timeLimit === 1?'限制':'不限制'}}
          </template>
        </el-table-column>
        <!-- BUG-2026-660473：按北京时间显示未开始/进行中/已过期及倒计时，activityNow 每秒刷新 -->
        <el-table-column label="时间状态" align="center" width="280">
          <template slot-scope="{row}">
            <time-status :time-limit="row.timeLimit" :start-time="row.startTime" :end-time="row.endTime" :now="activityNow" />
          </template>
        </el-table-column>
        <!-- BUG-2026-208896：起止时间分两行且不折行，避免把结束时间的年份拆开 -->
        <el-table-column label="活动时间（北京时间）" prop="orderNo" sortable="custom" align="center" width="180">
          <template slot-scope="{row}">
            <template v-if="row.timeLimit === 1">
              <div class="activity-time-line">{{formatActivityTime(row.startTime)}}</div>
              <div class="activity-time-line">{{formatActivityTime(row.endTime)}}</div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="活动规则" prop="activityRule" align="center" />
        <el-table-column label="参与活动身份" prop="name" align="center">
          <template slot-scope="{row}">
            <span v-for="(item,index) in row.customerLevelList" :key="index">{{item.name}}{{row.customerLevelList.length - 1 != index?',':''}}</span>
          </template>
        </el-table-column>

        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="activityStatus" align="center" width="100">
          <template slot-scope="{row}">
            <el-switch v-model="row.activityStatus" :active-value="1" :inactive-value="0" @change="changeSwitch(row)" v-hasPermi="['goods:activity:state']"></el-switch>
            {{row.activityStatus?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['goods:activity:edit']">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <activity-add ref="activityAdd" :now="activityNow" @created="doQueryList({})" />
  </div>
</template>

<script>
import activityAdd from './add'
import goodsActivityApi from '@/api/goods/goodsActivity'
import Pagination from '@/components/Pagination'
import { payModesText, isPayModesDerived, rewardText } from './activityEnum'
import timeStatus from './timeStatus'
import { formatActivityTime } from './activityTime'

export default {
  components: {
    Pagination,
    activityAdd,
    timeStatus
  },
  data() {
    return {
      activityNow: Date.now(),
      activityClockTimer: null,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        activityName: undefined,
        activityType: undefined,
        timeLimit: undefined,
        goodsName: undefined,
        activityStatus: undefined,
      },
      selectItems: [],
      dateTime: [],
      activeName: '2',
      categorizeOptions: [],  //活动分类
    }
  },
  created() {
    this.activityClockTimer = setInterval(() => {
      this.activityNow = Date.now()
    }, 1000)
    this.doQueryList({ pageNo: 1 })
  },
  beforeDestroy() {
    clearInterval(this.activityClockTimer)
    this.activityClockTimer = null
  },
  methods: {
    formatActivityTime,
    payModesText,
    isPayModesDerived,
    rewardText,
    handleFilter() {
      this.query = {}
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择活动')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 0)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 1)
      }
    },
    handleBatchState(ids, type) {
      let txt = type ? '确认将选中活动批量上架?' : '确认将选中活动批量下架?'
      this.$common.confirm(txt).then(() => goodsActivityApi.updateState({ id: ids, status: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },

    changeSwitch(row) {
      goodsActivityApi.updateState({ id: [row.id], status: row.activityStatus }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.activityWay = +this.activeName
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.listLoading = true
      return goodsActivityApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => goodsActivityApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择活动')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => goodsActivityApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },

    handleDownload() {
      const query = {
        ...this.query,
        activityWay: +this.activeName,
        startTime: this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined,
        endTime: this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      }
      delete query.pageNo
      delete query.pageSize
      if (this.selectItems.length) query.ids = this.selectItems.map(row => row.id).join(',')
      return this.$common.confirm('是否确认导出')
        .then(() => goodsActivityApi.exportExcel(query))
    },
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.activityAdd.handleCreate(this.total)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.activityAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=23&id=" + row.id);
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-time-line {
  white-space: nowrap;
}
</style>
